import React from 'react'
import {
  Box,
  SwipeableDrawer,
  Button,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import {
  Agriculture,
  Mail,
  PestControl,
} from '@mui/icons-material'
import DehazeIcon from '@mui/icons-material/Dehaze'
import { Link } from 'react-router-dom'

import { PropTypes } from 'prop-types'
import {
  commonLinks, publicLinks, privateLinks, cartLinks,
} from '../../../utils/User/constants/header/mobileHeader'

const NavDrawer = ({ headerLinks }) => {
  const [ state, setState ] = React.useState({
    // top: false,
    left: false,
    // bottom: false,
    // right: false,
  })

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event
      && event.type === 'keydown'
      && (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }

    setState({ ...state, [ anchor ]: open })
  }
  // TODO: Map the icon with respect to key
  const list = (anchor) => (
    <Box
      // sx={ { width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 } }
      sx={ { width: '250px' } }
      role='presentation'
      onClick={ toggleDrawer(anchor, false) }
      onKeyDown={ toggleDrawer(anchor, false) }
    >
      <List>
        {headerLinks.map((text, index) => (
          <>
            <Link key={ text.value } to={ text.link }>
              <ListItem disablePadding sx={ { color: '#343a40' } }>
                <ListItemButton>
                  <ListItemIcon>
                    {index % 2 === 0 ? <Agriculture /> : <PestControl />}
                  </ListItemIcon>
                  <ListItemText primary={ text.label } />
                </ListItemButton>
              </ListItem>
            </Link>
            { text?.showDivider && <Divider /> }
          </>
        ))}
      </List>
      {/* <List>
        {cartLinks.map((text, index) => (
          <Link key={ text.value } to={ text.link }>
            <ListItem disablePadding sx={ { color: '#343a40' } }>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <Agriculture /> : <PestControl />}
                </ListItemIcon>
                <ListItemText primary={ text.label } />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
      <List>
        {publicLinks.map((text, index) => (
          <Link key={ text.value } to={ text.link }>
            <ListItem disablePadding sx={ { color: '#343a40' } }>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <Agriculture /> : <PestControl />}
                </ListItemIcon>
                <ListItemText primary={ text.label } />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List> */}
    </Box>
  )

  return (
    <div>
      {/* {[ 'left', 'right', 'top', 'bottom' ].map((anchor) => ( */}
      <React.Fragment key='left'>
        <DehazeIcon sx={ { color: 'white' } } onClick={ toggleDrawer('left', true) } />
        <SwipeableDrawer
          anchor='left'
          open={ state.left }
          onClose={ toggleDrawer('left', false) }
          onOpen={ toggleDrawer('left', true) }
        >
          {list('left')}
        </SwipeableDrawer>
      </React.Fragment>
      {/* ))} */}
    </div>
  )
}

NavDrawer.propTypes = {
  headerLinks: PropTypes.arrayOf.isRequired,
}

export default NavDrawer
